/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ContentDtos { 
    name?: string;
    contentId?: string;
    description?: string;
    commandRecordId?: string;
    contentPrivacyTypeId?: number;
    isDeleted?: boolean;
    dateCreated?: Date;
    contentProviderName?: string;
    contentProviderId?: string;
}